<div fxLayout="column" class="chart-custom-categories-component">
    @if (isCustomStructure) {
        <app-highcharts-render
            style="height: 100%"
            [chartStructure]="chartStructure"
        ></app-highcharts-render>
    } @else {}
    <app-highcharts-render
        class="full-height"
        [options]="options"
        [visualization]="visualization"
        [series]="series"
        [points]="points"
        [company]="company"
    ></app-highcharts-render>
</div>
